import styled from "styled-components";
import { responsive } from "Styles/Constants";
import { COLORS } from "Styles/Constants";


//IMAGES
import { ReactComponent as InstaIcon } from "../../Assets/Images/Header/Instagram.svg";
import PageHeadingTop from "../../Assets/Images/PageHeading/breadcrumb_top.svg";
import PageHeadingMobile from "../../Assets/Images/PageHeading/vecotor_top_mobile.svg";
import PageHeadingBottom from "../../Assets/Images/PageHeading/breadcrumb_bottom.svg";



export const PageHeadingContainer = styled.div`
   font-family: 'Outfit', sans-serif;

    .pageheading_section{
        background: #FFF9EB; 
        padding: 50px 0;
        position: relative;
        &:before {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            width: 100%;
            height: 100%;
            background: url(${PageHeadingTop}) no-repeat;
            background-size: contain;
            background-position: top right;
        }

        &:after {
            content: "";
            position: absolute;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 100%;
            background: url(${PageHeadingBottom}) no-repeat;
            background-size: contain;
            background-position: left bottom;
        }
        .mygrid-container{
            position:relative;
            z-index:1;
        }
    }
    nav.breadcrumb_page_heading span{
        color: #EE2D2F;
    }
    nav.breadcrumb_page_heading a {
        text-decoration: none;
        color: #021E40;
    }

  }

@media (max-width: 991px) {
    .pageheading_section:after{
        background-size: 325px;
    }
    .pageheading_section:before{
        background-size: contain !important;
        background-position: right !important;
        background: url(${PageHeadingMobile}) no-repeat;
    }


}

@media (max-width: 767px) {
    .pageheading_section:after{
        background-size: 230px;
    }
    .pageheading_section:before{
        background-size: 250px;
        display: none;
    }
}

`;

